import { FindDoctorsView } from './view';
import { flowRight } from 'lodash';
import { injectIntl } from 'react-intl';

export default flowRight(
    injectIntl,
)(FindDoctorsView);
